import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTable: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconTable"><Path d="M3 3.75C3 3.33579 3.33579 3 3.75 3H9V9H3V3.75Z" fill="currentColor"/><Path d="M3 10.5V20.25C3 20.6642 3.33579 21 3.75 21H9V10.5H3Z" fill="currentColor"/><Path d="M10.5 21H20.25C20.6642 21 21 20.6642 21 20.25V10.5H10.5V21Z" fill="currentColor"/><Path d="M21 9V3.75C21 3.33579 20.6642 3 20.25 3H10.5V9H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTable;
